/**
* 顶部菜单组件
* Created by hmj on 2020/03/30.
*/
<template>
  <div class="middle-tab" :class="{ 'middle-tab-top': isTop }">
    <!-- 标题形式展示 -->
    <div class="middle-tab-title" v-if="menutype == 'title'">
      <span>{{ title }}</span>
    </div>

    <!-- 居中菜单列表跳转链接切换展示 -->
    <div class="middle-tab-menu" v-if="menutype == 'menu'">
      <div class="title" v-if="title">
        {{ title }}
      </div>
      <div class="details-router">
        <router-link
          :class="{ select: item.select }"
          :to="item.path"
          v-for="(item, i) in menuList"
          :key="i"
        >
          {{ item.name }}
          <b class="super" v-if="Number(item.number) > 0">{{ item.number }}</b>
        </router-link>
      </div>
    </div>

    <!-- 居中菜单列表页面内切换展示 -->
    <div class="middle-tab-inside" v-if="menutype == 'inside'">
      <div class="title" v-if="title">
        {{ title }}
      </div>
      <div class="menu-list">
        <div
          class="menu-info"
          :class="{ select: item.select }"
          v-for="item in menuList"
          @click="callMethod(item.active)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>

    <!-- 居中菜单列表页面内锚点切换展示(兼容链接) -->
    <div class="middle-tab-anchor" v-if="menutype == 'anchor'">
      <div class="title" v-if="title">
        {{ title }}
      </div>
      <div class="menu-list">
        <template v-for="item in menuList">
          <router-link
            target="_blank"
            class="menu-info"
            v-if="item.path"
            :to="item.path"
          >
            {{ item.name }}
            <b class="super" v-if="Number(item.number) > 0">{{
              item.number
            }}</b>
          </router-link>
          <div
            v-else
            class="menu-info"
            :class="{ select: activeAnchor == item.active }"
            @click="anchorSwitch(item.active)"
          >
            {{ item.name }}
          </div>
        </template>
      </div>
    </div>

    <!-- 路径（面包屑）形式展示 -->
    <div class="middle-tab-path" v-if="menutype == 'path'">
      <div class="details-router">
        <div
          class="menu-list"
          v-if="menuList.length === 0"
          v-for="(item, i) in crumbsList"
          :key="i"
        >
          <i class="iconfont" v-if="i > 0">&#xe626;</i>
          <router-link
            :class="{ no: i == crumbsList.length - 1 }"
            :to="item.path"
          >
            {{ item.name }}
          </router-link>
        </div>

        <div
          class="menu-list"
          v-if="menuList.length !== 0"
          v-for="(item, i) in menuList"
          :key="i"
        >
          <i class="iconfont" v-if="i > 0">&#xe626;</i>
          <router-link
            :class="{ no: i == menuList.length - 1 }"
            :to="item.path"
          >
            {{ item.name }}
          </router-link>
        </div>
      </div>
    </div>

    <!-- 面包屑（自动获取）形式展示 -->
    <div class="middle-tab-path" v-if="menutype == 'crumbs'">
      <div class="details-router">
        <div class="menu-list" v-for="(item, i) in crumbsList" :key="i">
          <i class="iconfont" v-if="i > 0">&#xe626;</i>
          <router-link
            :class="{ no: i == crumbsList.length - 1 }"
            :to="item.path"
          >
            {{ item.name }}
          </router-link>
        </div>
      </div>
    </div>
    <slot name="right" />
    <!--返回按钮-->
    <span class="go-back" v-if="parentPath != ''" @click="goBack"
      ><i class="fa fa-reply"></i> 返回</span
    >
  </div>
</template>

<script>
export default {
  name: "middle-tab",
  components: {},
  props: {
    isTop: {
      default: false,
    },
    menutype: {
      default: "title",
    },
    title: {
      default: "",
    },
    menuList: {
      default: function () {
        return [];
      },
    },
    pathtype: {
      default: "",
    },
    parentPath: {
      default: "",
    },
    active: {
      default: "",
    },
  },
  data() {
    return {
      activeAnchor: "",
      curPath: "",
      curMatched: [],
      curParam: "",
      path: this.$store.state.path,

      //面包屑
      crumbsList: [],
    };
  },
  watch: {
    $route: function () {
      this.getPath();

      if (
        this.menutype == "crumbs" ||
        (this.menutype == "path" && this.menuList.length === 0)
      ) {
        this.getCrumbsList();
      }
    },
  },
  methods: {
    /**
     * 获取面包屑
     * 指定面包屑菜单类型或路径菜单类型且传值为空数据时调用
     * */
    getCrumbsList() {
      let list = this.$route.matched,
        params = this.$route.params;
      this.crumbsList = [];
      list.forEach((item) => {
        let title = item.meta.title,
          path = item.path ? item.path : "/";

        if (title) {
          //关联参数替换
          if (path.indexOf("/:") > -1) {
            for (let key in params) {
              path = path.replace("/:" + key, "/" + params[key]);
            }
          }
          let data = { name: title, path: path };
          this.crumbsList.push(data);
        }
      });
    },

    getPath() {
      this.path = this.$route.path;
      if (
        !this.path ||
        this.path == null ||
        this.path == "" ||
        typeof this.path == "undefined"
      ) {
        this.path = document.URL.split("//")[1];
      }
      let path = JSON.parse(JSON.stringify(this.path));
      if (this.pathtype != "parameter") {
        //是否清除参数
        if (path.indexOf("?") > -1) {
          path = path.split("?")[0];
        }
      }
      let data = path.split("/");
      this.curMatched = data;
      this.curPath = data[data.length - 1];
      this.matchedMenuData();
    },

    //匹配数据
    matchedMenuData() {
      //支持类型
      let type = ["menu"]; /*'inside', */
      //类型对应关键字
      let typeNameMap = { menu: "curMenu" }; /*'inside': 'active',*/

      if (type.indexOf(this.menutype) > -1) {
        this.menuList.forEach((item) => {
          let name = item[typeNameMap[this.menutype]];
          //是否需要指定路径层级（注意：根据路径绝对层级，需包含路径中的动态参数id等）
          if (Number(item.level) > -1) {
            if (this.curMatched[item.level] == name) {
              this.$set(item, "select", true);
            } else {
              this.$set(item, "select", false);
            }
          } else {
            if (this.curPath == name) {
              this.$set(item, "select", true);
            } else {
              this.$set(item, "select", false);
            }
          }
        });
      }
    },

    //返回上一步
    goBack() {
      if (this.parentPath != "") {
        this.$router.push(this.parentPath);
      }
    },

    //调用父级方法
    callMethod(active) {
      //父级引用方式：@childMethod="childMethod"，引号内方法可自定义
      //第一个参数名为调用的方法名，第二个参数为需要传递的参数
      this.$emit("childMethod", active);
    },
    // 锚点切换
    anchorSwitch(active) {
      //偏差值（减去顶部框架高度）
      let deviationValue = 60;
      // deviationValue += $("body,html").scrollTop()

      let scrollTop = $("#" + active).offset().top;
      //是否需要考虑顶部菜单遮挡问题
      if (this.isTop) {
        scrollTop -= 50;
      }

      // console.log("滚动距离")
      // console.log(deviationValue)
      // console.log(scrollTop)

      $("body,html").animate(
        {
          scrollTop: scrollTop - deviationValue,
        },
        800,
        function () {
          // window.location.hash = '#' + val;
        }
      );

      //父级引用方式：@childMethod="childMethod"，引号内方法可自定义
      //第一个参数名为调用的方法名，第二个参数为需要传递的参数
      this.$emit("anchorSwitch", active);
    },

    //是否开启锚点自动定位
    middleTabAnchor() {
      if (this.menutype === "anchor") {
        //初始化首个锚点选中效果
        this.activeAnchor = this.menuList[0].active;

        this.menuList.forEach((item, index) => {
          let active = item.active;
          if (active) {
            let scrollTop = $("#" + active).offset().top - 50;
            let height = $("#" + active).height() + scrollTop;

            this.anchorPositioning(active, scrollTop, height);
          }
        });
      }
    },
    //锚点自动定位设置
    anchorPositioning(active, top, bottom) {
      let _this = this;
      //偏差值（减去顶部框架高度）
      let deviationValue = 50;
      //是否需要考虑顶部菜单遮挡问题
      if (this.isTop) {
        deviationValue += 50;
      }
      // console.log("元素" + active)
      // console.log("顶部" + top)
      // console.log("底部" + bottom)

      $(window).scroll(function (e) {
        let scrollTop = $(this).scrollTop() + deviationValue;

        //子元素距离顶部高度需要包含顶级元素当前滚动距离
        if (scrollTop > top && scrollTop < bottom) {
          _this.activeAnchor = active;
          /*console.log("当前滚动" + scrollTop)
          console.log("当前元素" + active)
          console.log("顶部" + top)
          console.log("高度" + bottom)*/
        }
      });
    },

    //是否居顶
    middleTabTop() {
      //是否居顶
      if (this.isTop) {
        let _this = this;
        //滚动偏差值
        let deviationValue = -50;
        // console.log($('.middle-tab-top').offset())
        //距离顶部高度
        let top = $(".middle-tab-top").offset().top;

        let scrollTop = $(window).scrollTop();
        // console.log("滚动距离" + top)
        _this.middleTabFixed(deviationValue, top, scrollTop);

        $(window).scroll(function (e) {
          let scrollTop = $(this).scrollTop();
          // console.log("滚动距离" + top)
          _this.middleTabFixed(deviationValue, top, scrollTop);
        });
      }
    },

    //判断是否居顶
    middleTabFixed(deviationValue, top, scrollTop) {
      if (scrollTop >= deviationValue + top) {
        // console.log("滚动距离" + scrollTop)
        $(".middle-tab-top").addClass("middle-tab-fixed");
      } else {
        $(".middle-tab-top").removeClass("middle-tab-fixed");
      }
    },
  },
  created() {
    this.getPath();

    if (
      this.menutype == "crumbs" ||
      (this.menutype == "path" && this.menuList.length === 0)
    ) {
      this.getCrumbsList();
    }
  },
  mounted() {
    this.getPath();

    let _this = this;
    this.$nextTick(() => {
      //判断是否居顶
      _this.middleTabTop();

      //启动锚点自定定位
      _this.middleTabAnchor();
    });
  },
};
</script>

<style lang="stylus" type="text/stylus" scoped>
.middle-tab {
  margin-bottom: 20px;
  height: 50px;
  width: 100%;
  min-width: 1100px;
  margin-right: 20px;
  z-index: 100;
  position: relative;
  display: flex;
  justify-content: space-between;
  background: #ffffff;
  box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 0 0 0 rgba(0, 0, 0, 0.02);
  color: #666666;

  &.middle-tab-top {
    &.middle-tab-fixed {
      > div {
        position: fixed;
        top: 50px;
        left: 0;
        right: 0;
      }
    }
  }

  .middle-tab-path {
    display: block;
    text-align: left;
    background: #ffffff;
    height: 100%;
    padding: 0 20px;
    line-height: 50px;
    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 0 0 0 rgba(0, 0, 0, 0.02);
    color: #666666;
    border-radius: 5px;

    i {
      display: inline-block;
      margin: 0 10px;
    }

    .details-router {
      height: 100%;
    }

    .menu-list {
      font-size: 0;
      display: inline-block;
      line-height: 50px;
      vertical-align: top;
      height: 100%;

      .arrow {
        display: inline-block;
        font-size: 14px;
        margin: 0 10px;
        vertical-align: top;
      }

      a {
        display: inline-block;
        font-size: 14px;
        color: #666666;
        vertical-align: top;

        &:hover, &.no {
          color: #436cf4;
        }
      }
    }
  }

  .middle-tab-menu {
    display: block;
    text-align: center;
    background: #ffffff;
    border-radius: 5px;
    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 0 0 0 rgba(0, 0, 0, 0.02);
    color: #666666;
    position: relative;
    z-index: 1;

    .title {
      display: inline-block;
      position: absolute;
      left: 26px;
      top: 0;
      height: 50px;
      line-height: 50px;
      font-size: 14px;
      font-weight: bold;
    }

    .details-router {
      line-height: 50px;

      a {
        display: inline-block;
        padding: 0 20px;
        color: #666666;
        margin: 0 5px;
        position: relative;

        .super {
          display: inline-block;
          padding: 4px 0;
          background-color: #f25c8e;
          line-height: 10px;
          font-size: 12px;
          transform: scale(0.8);
          color: #fff !important;
          font-weight: 400;
          margin-left: 16px;
          height: 18px;
          position: absolute;
          top: -3px;
          right: 4px;
          z-index: 1;

          &:after {
            position: absolute;
            right: -8px;
            top: 0;
            background-color: #f25c8e;
            content: '';
            display: inline-block;
            width: 9px;
            height: 18px;
            border-radius: 0 14px 14px 0;
            z-index: -1;
          }

          &:before {
            position: absolute;
            left: -8px;
            top: 0;
            background-color: #f25c8e;
            content: '';
            display: inline-block;
            width: 9px;
            height: 18px;
            border-radius: 14px 0 0 14px;
            z-index: -1;
          }
        }
      }

      a:hover, a.router-link-exact-active, a.select {
        height: 50px;
        color: #436cf4;
        border-bottom: 4px solid #436cf4;
      }
    }
  }

  .middle-tab-inside {
    display: block;
    text-align: center;
    background: #ffffff;
    border-radius: 5px;
    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 0 0 0 rgba(0, 0, 0, 0.02);
    color: #666666;
    position: relative;

    .title {
      display: inline-block;
      position: absolute;
      left: 26px;
      top: 0;
      height: 50px;
      line-height: 50px;
      font-size: 14px;
      font-weight: bold;
    }

    .menu-list {
      padding-top: 10px;
      line-height: 40px;

      .menu-info {
        display: inline-block;
        padding: 0 20px;
        color: #666666;
        margin: 0 5px;
        position: relative;
        cursor: pointer;
        -moz-user-select: none;
        -webkit-user-select: none;
        user-select: none;
      }

      .menu-info:hover, .menu-info.select {
        height: 40px;
        color: #666666;
        font-weight: bold;
        border-bottom: 4px solid #436cf4;
      }

      .menu-info:hover {
        height: 40px;
        color: #666666;
        border-bottom: 4px solid #436cf4;
      }
    }
  }

  .middle-tab-anchor {
    display: block;
    text-align: center;
    background: #ffffff;
    border-radius: 5px;
    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 0 0 0 rgba(0, 0, 0, 0.02);
    color: #666666;
    position: relative;

    .title {
      display: inline-block;
      position: absolute;
      left: 26px;
      top: 0;
      height: 50px;
      line-height: 50px;
      font-size: 14px;
      font-weight: bold;
    }

    .menu-list {
      line-height: 50px;

      .menu-info {
        display: inline-block;
        padding: 0 20px;
        color: #666666;
        margin: 0 5px;
        position: relative;
        cursor: pointer;
        -moz-user-select: none;
        -webkit-user-select: none;
        user-select: none;
      }

      .menu-info:hover, .menu-info.select {
        height: 50px;
        color: #666666;
        font-weight: bold;
        border-bottom: 4px solid #436cf4;
      }
    }
  }

  .middle-tab-title {
    display: block;
    padding-left: 26px;
    height: 50px;
    line-height: 50px;
    background: #ffffff;
    border-radius: 5px;
    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 0 0 0 rgba(0, 0, 0, 0.02);

    span {
      font-size: 14px;
    }
  }

  .but {
    cursor: pointer;
  }

  .go-back {
    color: #a0a8b0;
    width: 70px;
    height: 26px;
    display: inline-block;
    border-radius: 13px;
    font-size: 12px;
    background: #fff;
    border: 1px solid #f0f0f0;
    box-shadow: 0 0 5px #dcdcdc;
    text-align: center;
    line-height: 24px;
    position: absolute;
    right: 20px;
    top: 12px;
    z-index: 2;
    cursor: pointer;

    &:hover {
      background: #f0f0f0;
    }

    i {
      margin-right: 6px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/middle-tab/middle-tab.vue